export var link = function link(text, attrs) {
  return "[".concat(text, "|").concat(attrs.href, "]");
};